import React from "react";


import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
// import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../Constants";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import { Modal, Button } from 'react-bootstrap';
import { Spinner } from "reactstrap";
import { FaTimes, FaEdit, FaFileExport, FaArrowRight, FaCheckCircle, FaTimesCircle, FaList } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import './style.css'
import StaffAttendanceDetails from "./StaffAttendanceDetails";

const StaffAttendanceSummary = (props) => {


  const history = useHistory();

  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);


  const [isLoading, setIsLoading] = useState(false);
    const date = new Date();
  const [year, setyear] = useState(date.getFullYear());
  const [month, setmonth] = useState(date.getMonth() + 1);

 

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);

  useEffect(() => {
    listAttendanceSummary();

    return () => { };
  }, []);


  const listAttendanceSummary = () => {
    setIsLoading(true);
    genericPost(ENDPOINTS.STAFF_ATTENDANCE_SUMMARY, {

      "month": month,
      "year": year

    })
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {

          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;

            setRowData(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };
  const handleGenerateTs = (selectedRecord) => {
    alert(JSON.stringify(selectedRecord));
  }

//MODAL 
  const [modal_loading, setmodal_loading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
    const [showModal, setShowModal] = useState(false);
  
    // Handle row click
    const onRowClicked = (event) => {
      alert(JSON.stringify(event.data));
      console.log(event.data);
      let data={ "staff": event.data, "month": month, "year": year };
      setmodal_loading(false);
      setSelectedRowData(data);  // Set selected row data
      setShowModal(true);  // Show the modal
    };
  
    // Close modal
    const closeModal = () => {
      setShowModal(false);
    };
  return (
    <div>
      <Loader loading={isLoading} />
      <div className="row">
        <div className="col-md-5">
          <h1>  Staff Attendance Summary   </h1>
        </div>
        <hr />
        <div className="col-md-10">

          <div className="row">

            {/* <CardBox title={"TOTAL EMPLOYEES"} value={payroll_info?.total_employees} icon={"fa fa-group"}  ></CardBox>
<CardBox title={" Total Payroll "} value={payroll_info?.total_payroll} icon={"fa fa-dollar"}  ></CardBox>
<CardBox title={" Cash Required "} value={payroll_info?.cash_required} icon={"fa fa-dollar"}  ></CardBox>
<CardBox title={"   Total Tax "} value={payroll_info?.total_tax} icon={"fa fa-dollar"}  ></CardBox> */}


            <div className="row">
              <div className='col-md-3'>
                Month
                <select name="month"
                  value={month}
                  className="form-control"
                  onChange={(e) => { setmonth(e.target.value) }


                  }
                  required={true}
                >
                  <option value=''>Select Month </option>
                  <option value={1}>January </option>
                  <option value={2}>February </option>
                  <option value={3}>March </option>
                  <option value={4}>April </option>
                  <option value={5}>May </option>
                  <option value={6}>Jun </option>
                  <option value={7}>July </option>

                  <option value={8}>August </option>
                  <option value={9}>September </option>
                  <option value={10}>October </option>
                  <option value={11}>November </option>
                  <option value={12}>December </option>
                </select>
              </div>
              <div className='col-md-3'>
                Year
                <input className="form-control" name="year" value={year} onChange={(e) => setyear(e.target.value)} required={true}></input>

              </div>
              <div className="col-md-1"> <br />
                <button className="btn-sm btn-primary" onClick={() => listAttendanceSummary()}>View</button>
              </div>
            </div>
            {/* <div className="col-md-3"> <br />
              <button className="btn btn-primary" onClick={() => alert("The engine is under maintenance. Please try again later")}>Generate Monthly TS </button>
            </div> */}






          </div>
        </div>
      </div>

      <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          rowSelection={"multiple"}
          groupSelectsChildren={true}
          suppressRowClickSelection={true}
          // onRowClicked={onRowClicked}
          onRowDoubleClicked={(e) => {

            if (e.data?.staff_id != null) {
              history.push({
                pathname: "/hrm/attendance/attendance-details",
                state: { data: { staff: e.data, month: month, year: year } },
              });
            } else {

              return;
            }
          }}



          onSelectionChanged={(e) => {
            if (e.data?.staff != null) {
              //calculate_tests();
            }
          }}

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            //  params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}

          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },
            {

              headerName: "ID",
              field: "id",
              sortable: true,
              filter: true,
              hide: true
            },
             {

              headerName: "Staff ID",
              field: "staff_id",
              sortable: true,
              filter: true,
              hide: true
            }, 
            {

              headerName: "Staff Name",
              field: "staff_name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Email",
              field: "email",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Office",
              field: "office",
              sortable: true,
              filter: true,
            }, {
              headerName: "Designation",
              field: "designation",
              sortable: true,
              filter: true,
            }, {
              headerName: "Total Attended",
              field: "total_attended_days",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Annual Leave Attended",
              field: "annual_leave_days",
              sortable: true,
              filter: true,
            }, {
              headerName: "Sick Leave",
              field: "sick_leave_days",
              sortable: true,
              filter: true,
            }, {
              headerName: "Holiday",
              field: "holiday_days",
              sortable: true,
              filter: true,
            }, {
              headerName: "Budget Lines",
              field: "budgetlines",
              sortable: true,
              filter: true,
              hide: true
            },

           
            // {
            //   headerName: 'Actions',
            //   field: 'actions',
            //   minWidth: 200,
            //   sortable: false,
            //   filter: false,
            //   cellRendererFramework: (e) => {
            //     // console.log("EEEEEE");
            //     // console.log(e);
            //     return (
            //       <span className="level-top mb-5">
            //         {/* <button
            //   className="badge btn-success"
            //   onClick={() => {
            //     let data = e.data;
            //  alert(JSON.stringify(data));
            //   }}
            // > */}
            //         <span>
            //           <button className="btn btn-primary btn-md" onClick={() => {
            //             let data = e.data;
            //             handleGenerateTs(data);
            //             //  alert(JSON.stringify(data));
            //           }}
            //           >
            //             <FaList style={{ color: "white", cursor: "pointer" }} /> &nbsp; Generate TS
            //           </button>
            //         </span>
            //         {/* <FaEye style={{ color: "white", cursor: "pointer" }} /> */}
            //         {/* </button> */}
            //       </span>
            //     );
            //   }

            // }


          ]}
        ></AgGridReact>
      </div>{" "}

      <hr />



<Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        dialogClassName="modal-left"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title" style={{ textAlign: 'center', color: 'white' }}>
            <center><h1> STAFF ATTENDANCE DETAILS</h1></center>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <StaffAttendanceDetails 
  details={selectedRowData} 
/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>



  );
};

export default StaffAttendanceSummary;



